import { useApi } from './useApi';
import { apiService } from '../services/api';

interface AboutContentData {
  id: number;
  documentId: string;
  title: string;
  description: string;
  usp1?: {
    title: string;
    description: string;
    icon: string;
  };
  usp2?: {
    title: string;
    description: string;
    icon: string;
  };
  usp3?: {
    title: string;
    description: string;
    icon: string;
  };
  createdAt: string;
  updatedAt: string;
  publishedAt: string;
}

export function useOverOnsAboutContent() {
  return useApi<AboutContentData>(apiService.getAboutSection);
}